import { ClassThemeProvider } from '@class-ui/theme';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ClassroomContent } from '../components/classroom/ClassroomContent';
import { type LtiRoutesParams } from '../components/classroom/ClassroomRoutes';
import { ClassroomSessionContent } from '../components/classroom/ClassroomSessionContent';
import { SubClassContainer } from '../components/classroom/SubClasses/SubClassContainer';
import Loadable from '../components/common/loadable';
import { ClassProvider } from '../context/ClassContext';
import DownloadChatContainer from '../views/AdminSettings/DownloadChatContainer';

const Classroom = () => {
    const { ready } = useTranslation('lti');
    const { classUuid, classSessionUuid } = useParams<LtiRoutesParams>();

    return (
        <Loadable isLoading={!ready}>
            <ClassThemeProvider>
                <ClassProvider classUuid={classUuid} classSessionUuid={classSessionUuid}>
                    <DownloadChatContainer.Provider>
                        <SubClassContainer.Provider>
                            {classSessionUuid ? (
                                <ClassroomSessionContent classSessionUuid={classSessionUuid} />
                            ) : (
                                <ClassroomContent />
                            )}
                        </SubClassContainer.Provider>
                    </DownloadChatContainer.Provider>
                </ClassProvider>
            </ClassThemeProvider>
        </Loadable>
    );
};

export default Classroom;
